import { z } from 'zod/v4';

import { normalizeLogoWidgetArgs } from './logo-widget-args.normalization';
import { partialLogoWidgetDataSchema } from './partial-logo-widget-data.schema';

/**
 * `data` stays OPTIONAL — like the standalone-image-widget's `image: null` default, a logo with no
 * file picked yet is a complete, meaningful request; the editor itself creates one this way.
 *
 * `logo` widgets can only be created inside the site's header or footer, and at most one may exist
 * per header/footer — both enforced by `apps/mcp-backend`, not by this schema (there is no
 * column-tree context here to check against).
 */
const createLogoWidgetObjectSchema = z.object({
    columnId: z
        .string()
        .describe(
            'Id of the column to create the logo widget in. Must be a column inside the site header or ' +
                'footer — call get_page_snapshot first to find one, or create_block with role: "header"/"footer".'
        ),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: partialLogoWidgetDataSchema
        .optional()
        .describe('Logo settings. Omit entirely to create a logo with no image picked yet.'),
});

export const createLogoWidgetArgsSchema = z.preprocess(normalizeLogoWidgetArgs, createLogoWidgetObjectSchema);
